const SVG_DATA_URI_PREFIX = "data:image/svg+xml;utf8,";

export const getSvgDataUri = (value: unknown): string =>
	typeof value === "string" && value.trim().length > 0
		? `${SVG_DATA_URI_PREFIX}${encodeURIComponent(value)}`
		: "";
